<template>
  <el-footer class="footer-container">
    <div class="footer-content">
      <!-- 用 el-row 做外层容器，借助 Element Plus 栅格系统更灵活 -->
      <el-row :gutter="20" class="footer-columns">
        <el-col :span="8" :xs="24" :sm="12" :md="8">
          <div class="footer-column">
            <h3>关于我们</h3>
            <ul class="address-list">
              <li>
                <strong>石家庄总部地址:</strong>
                石家庄市鹿泉经济开发区御园路99号光谷科技园光谷金城科技园1栋6楼
              </li>
              <li>
                <strong>衡水分公司地址:</strong>
                衡水市桃城区中湖大道4399号中湖数字产业园A区一层
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="6" :xs="24" :sm="12" :md="6">
          <div class="footer-column">
            <h3>咨询时间</h3>
            <p>热线咨询时间：周一至周日 8:00-22:00</p>
            <p>门店咨询时间：周一至周五 8:30-18:00</p>
          </div>
        </el-col>
        <el-col :span="6" :xs="24" :sm="12" :md="6">
          <div class="footer-column">
            <h3>联系我们</h3>
            <p>咨询热线: 0311-82186581</p>
            <p>王老师: 18631159504</p>
          </div>
        </el-col>
        <el-col :span="4" :xs="24" :sm="12" :md="4">
          <!-- 新增图片 -->
          <div class="social-media">
            <img
              :src="contactImage"
              alt="联系方式二维码"
              class="contact-qr-code"
            />
          </div>
        </el-col>
      </el-row>
      <div class="footer-bottom">
        <p>2026砺兵军招升学规划网版权所有</p>

        <!-- 备案信息 -->
        <p class="icp-info">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            >冀ICP备2022000014号</a
          >
        </p>
        <!-- 添加浏览量展示 -->
        <p class="pageview">当前浏览量: {{ pageview }}</p>
      </div>
    </div>
  </el-footer>
</template>

<script setup>
import contactImage from "@/assets/llll.png";
import { getPageview, savePageview } from "@/api/footApi";
import { ref, onMounted } from "vue";

const pageview = ref(0);

// 页面加载时调用保存函数
onMounted(async () => {
  await savePageview(); // 先保存一次浏览量
  const res = await getPageview(); // 再获取最新数据
  //console.log("-----");
  //console.log(res.data.data[0].pageview);
  pageview.value = res.data.data[0].pageview;
});
</script>

<style scoped>
.footer-container {
  height: auto;
  background-color: #333;
  color: white;
  padding: 40px 20px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-columns {
  width: 100%;
}

.footer-column {
  text-align: left;
}

.footer-column h3 {
  color: #fff;
  font-size: 18px;
  margin-bottom: 15px;
}

.address-list {
  list-style: none;
  padding: 0;
}

.address-list li {
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.6;
}

.address-list li strong {
  font-weight: bold;
}

.social-media {
  margin-top: 15px;
}

.social-media el-button {
  margin-right: 10px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  transition: background-color 0.3s;
}

.social-media el-button:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  margin-top: 20px;
  text-align: center;
  width: 100%;
}

.pageview {
  margin-top: 10px;
  font-size: 14px;
  color: #aaa;
}

.icp-info {
  margin-top: 10px;
  font-size: 14px;
  color: #aaa;
}

.icp-info a {
  color: #aaa;
  text-decoration: none;
  transition: color 0.3s;
}

.icp-info a:hover {
  color: #4c8aff;
}

.contact-qr-code {
  width: 120px;
  height: auto;
  margin-top: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-container {
    padding: 30px 15px;
  }

  .footer-column {
    text-align: center;
    margin-bottom: 25px;
  }

  .footer-column h3 {
    font-size: 16px;
    margin-bottom: 12px;
    border-bottom: 2px solid #4c8aff;
    padding-bottom: 8px;
    display: inline-block;
  }

  .address-list li {
    font-size: 13px;
  }

  .contact-qr-code {
    width: 100px;
  }

  .footer-bottom {
    margin-top: 30px;
    padding-top: 15px;
  }

  .footer-bottom p {
    font-size: 12px;
  }

  .pageview {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: 20px 10px;
  }

  .footer-column h3 {
    font-size: 14px;
  }

  .address-list li {
    font-size: 12px;
  }

  .contact-qr-code {
    width: 80px;
  }

  .footer-bottom p {
    font-size: 11px;
  }
}
</style>
